import { gardenApi, gardenVarietyApi, varietiesApi } from "@/services/api"

export default {
  namespaced: true,
  state: {
    garden: null,
    variantGroups: {},
    varieties: [],
    allVarieties: [],
    loading: false,
    error: null,
  },
  mutations: {
    SET_LOADING(state, val) { state.loading = val },
    SET_ERROR(state, err) { state.error = err },
    SET_DASHBOARD(state, data) {
      state.garden = data.garden
      state.variantGroups = data.variety_groups
      state.varieties = Object.values(data.variety_groups).flat()
    },
    SET_ALL_VARIETIES(state, list) { state.allVarieties = list },
    UPDATE_GV_STATUS(state, updated) {
      for (const cat of Object.keys(state.variantGroups)) {
        const idx = state.variantGroups[cat].findIndex((gv) => gv.id === updated.id)
        if (idx !== -1) {
          state.variantGroups[cat].splice(idx, 1, updated)
          break
        }
      }
    },
    REMOVE_GV(state, id) {
      for (const cat of Object.keys(state.variantGroups)) {
        state.variantGroups[cat] = state.variantGroups[cat].filter((gv) => gv.id !== id)
      }
    },
  },
  actions: {
    async loadDashboard({ commit }, gardenId) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const { data } = await gardenApi.dashboard(gardenId)
        commit("SET_DASHBOARD", data)
        return data
      } catch (e) {
        commit("SET_ERROR", e.message)
      } finally {
        commit("SET_LOADING", false)
      }
    },
    async loadAllVarieties({ commit }) {
      const { data } = await varietiesApi.list({ page_size: 500 })
      commit("SET_ALL_VARIETIES", data.results)
    },
    async toggleStatus({ commit }, gvId) {
      const { data } = await gardenVarietyApi.toggleStatus(gvId)
      commit("UPDATE_GV_STATUS", data)
    },
    async removeGardenVariety({ commit }, gvId) {
      await gardenVarietyApi.remove(gvId)
      commit("REMOVE_GV", gvId)
    },
  },
  getters: {
    byCategory: (state) => (cat) => state.variantGroups[cat] || [],
    sowingNow: (state) => {
      const month = new Date().toLocaleString("fr", { month: "short" }).slice(0, 3).toLowerCase()
      return state.varieties.filter((gv) =>
        ["si", "sd"].includes(gv.variety?.timeline?.[month])
      )
    },
  },
}
